import React, { forwardRef } from "react";
import { cn } from "./cn";

const Input = forwardRef(function Input(
  { label, icon: Icon, error, hint, className, containerClassName, ...props },
  ref
) {
  return (
    <div className={cn("w-full", containerClassName)}>
      {label && (
        <label className="mb-1.5 block text-start text-sm font-medium text-ink/90">{label}</label>
      )}
      <div className="relative">
        {Icon && (
          <Icon
            size={18}
            className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-faint"
          />
        )}
        <input
          ref={ref}
          className={cn(
            "h-11 w-full rounded-xl border bg-surface-2 px-3.5 text-sm text-ink outline-none transition",
            "placeholder:text-faint",
            "border-line focus:border-accent focus:ring-2 focus:ring-accent/30",
            Icon && "pl-10",
            error && "border-red-400 focus:border-red-400 focus:ring-red-400/30",
            className
          )}
          {...props}
        />
      </div>
      {error ? (
        <p className="mt-1 text-start text-xs text-red-500">{error}</p>
      ) : hint ? (
        <p className="mt-1 text-start text-xs text-muted">{hint}</p>
      ) : null}
    </div>
  );
});

export default Input;
